import { BoltSlashIcon } from '@heroicons/react/24/solid';

export const NotFoundIframeContent: React.FC<{ type: string }> = ({ type }) => {
  return (
    <div className="flex flex-auto flex-col items-center justify-center gap-[20px] p-l">
      <BoltSlashIcon className="size-[60px] fill-neutral-300" />
      <div className="flex flex-col items-center text-neutral-600">
        <div className="text-microMedium">
          Unable to load {type} data for this vehicle.
        </div>
        <div className="text-microNormal">
          Contact the dealership for more info.
        </div>
      </div>
    </div>
  );
};
